<template>
  <button class="db-table-action edit modal-btn">
    <i class="lab lab-edit-line"></i>
    <span class="db-tooltip">{{ $t('button.edit') }}</span>
  </button>
</template>

<script>
export default {
  name: 'SmIconModalEditComponent.vue'
}
</script>

<style scoped></style>
